import { Avatar, Box, Chip, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import type { Discount } from '../../types/models/Discount';

type DiscountTooltipProps = {
    discounts: Discount[];
    children?: React.ReactElement;
};

export default function DiscountTooltip({
    discounts,
    children,
}: DiscountTooltipProps) {
    const { t } = useTranslation();

    if (!discounts.length) {
        return null;
    }

    const tooltipContent = (
        <div
            // Establecer varias líneas para el Tooltip de MUI
            style={{
                whiteSpace: 'pre-line',
            }}
        >
            {discounts
                .map(
                    (discount) =>
                        `${discount.name} - ${discount.discountPercentage}%`,
                )
                .join('\n')}
        </div>
    );

    return (
        <Tooltip title={tooltipContent}>
            {children || (
                <Box mt={1}>
                    <Chip
                        size="small"
                        avatar={<Avatar>{discounts.length}</Avatar>}
                        label={t('generic.discounts')}
                    />
                </Box>
            )}
        </Tooltip>
    );
}
